export function normalizeLangCode(str: string) {
  return str.replace(/-(\w+)/, (match, p1) => "-" + p1.toUpperCase());
}
